import Header from "./components/header/Header";
import JobList from "./components/JobList/JobList";

function App() {
  return (
    <div className="App">
      <Header />
      <JobList />
    </div>
  );
}

export default App;
